import { render } from "./StatisticsAnalysis.vue?vue&type=template&id=605d5798"
import script from "./StatisticsAnalysis.vue?vue&type=script&lang=js"
export * from "./StatisticsAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__